import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Overline, Reveal } from "./Primitives";
import { useT } from "@/lib/i18n";

export const Faq = () => {
  const t = useT().faq;
  return (
    <section id="faq" className="py-24 md:py-36 bg-[var(--bg2)]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <Overline>{t.over}</Overline>
          <h2 className="mt-6 font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">{t.title}</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          <Accordion type="single" collapsible className="border-t border-[var(--line)]" data-testid="faq-list">
            {t.items.map((it, i) => (
              <AccordionItem key={it.q} value={`q${i}`} className="border-b border-[var(--line)]">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="py-6 text-left font-display text-xl md:text-2xl font-normal hover:no-underline hover:text-[var(--gold)]">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base text-stone-300 leading-relaxed">{it.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
